export default __webpack_public_path__ + "static/media/Wartsilainvestimentosullenavielettriche.89d559dc.pdf";